import { Alert as AlertAntD, Button as ButtonAntD, Input as InputAntD, Radio as RadioAntD, Select as SelectAntD, Steps as StepsAntD } from 'antd';
import styled from 'styled-components';

// Compartilhado entre TicketDrawer, InternalTicketDrawer, NewTicketModal e DynamicField
// (substitui os `style={{...}}` inline pelo padrao styled-components do resto do codebase).

export const SpacedAlert = styled(AlertAntD)`
  margin-bottom: 12px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const FieldGroup = styled.div`
  margin-bottom: 16px;
`;

export const FieldError = styled.div`
  color: #f5222d;
  font-size: 12px;
`;

export const ErrorText = styled.span`
  color: #f5222d;
`;

export const BlockSpacer = styled.div`
  margin-bottom: 12px;
`;

export const CommentBody = styled.div`
  white-space: pre-wrap;
`;

export const FullWidthSelect = styled(SelectAntD)`
  width: 100%;
`;

export const TopSpacedButton = styled(ButtonAntD)`
  margin-top: 8px;
`;

export const RightSpacedButton = styled(ButtonAntD)`
  margin-right: 8px;
`;

export const SpacedSteps = styled(StepsAntD)`
  margin-bottom: 24px;
`;

export const AttachmentRow = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
`;

export const AgentInput = styled(InputAntD)`
  width: 240px;
  margin-right: 8px;
`;

export const SpacedRadioGroup = styled(RadioAntD.Group)`
  margin-top: 8px;
`;

export const WarningNotice = styled.div`
  color: #d48806;
  font-size: 12px;
`;

export const MutedNotice = styled.div`
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 8px;
`;

export const FieldValue = styled.p`
  white-space: pre-wrap;
`;

export const CommentTimestamp = styled.span`
  margin-left: 8px;
  font-size: 12px;
  opacity: 0.7;
`;
